import { effectiveDriverStops, initialGateStatus } from "./driverStops";

/**
 * Whether a yard runs the driver check-in gate at all.
 *
 * The gate is one feature with several surfaces — the driver app, the crew and
 * manager Gate Queue pages, and the inline control on both shipment dispatch
 * tabs — and a yard that checks trucks in at the office runs none of them. Its
 * trucks are marked arrived and placed by a manager, and the crew work them
 * from the inbound/outbound baskets, exactly as they did before the gate queue
 * existed. Showing those surfaces there offers a workflow the yard does not
 * use, on rows that will never carry a check-in.
 *
 * Opt-in: only an explicit true turns the gate on. A yard holding null has
 * never been configured for it — nobody has posted its QR, chosen its grace
 * period, or told its crew that trucks now arrive through a queue — and
 * reading that silence as consent would switch the whole feature on for every
 * yard in the fleet the day it ships. driverApi (lib/yards.js) applies the same
 * test, and the two have to agree: a yard whose staff can see the Gate Queue
 * must be a yard whose drivers can reach the kiosk, and the reverse.
 */
export const yardRunsDriverCheckIn = (reloadYard) =>
  reloadYard?.driverCheckInEnabled === true;

/**
 * The same test for the yard the signed-in user works.
 *
 * Menus and routes have no record to hand — App.js hangs the whole yard off the
 * session at login (setupUserData), so they read it from there. Carrier and
 * customer sessions carry no gate surfaces at all, and a session still loading
 * has no yard: both read as off, so the menu settles into place rather than
 * offering a queue and withdrawing it.
 */
export const sessionYardRunsDriverCheckIn = () =>
  yardRunsDriverCheckIn(sessionReloadYard());

/** The signed-in user's yard record, as App.js hung it off the session. */
export const sessionReloadYard = () => window.appUser?.reloadYard;

/**
 * The yard's post-check-in stops, for the Gate Queue's stop dropdown and the
 * stop rules every gate write applies. Empty on a yard that listed none,
 * which is a yard with no waiting area — see src/utils/driverStops.js.
 */
export const yardDriverStops = (reloadYard) => effectiveDriverStops(reloadYard);

export const sessionYardDriverStops = () =>
  yardDriverStops(sessionReloadYard());

/**
 * The status a row minted for the session yard opens at. Read from the yard
 * record rather than its effective stops: a yard that never saved a stops list
 * waits, an empty saved list does not, and only the record tells them apart —
 * see src/utils/driverStops.js yardQueuesDrivers.
 */
export const sessionYardOpeningGateStatus = () =>
  initialGateStatus(sessionReloadYard());
